'use strict';
import * as $i_$0040ui5$002fwebcomponents$002fdist$002fInput$002ejs from "@ui5/webcomponents/dist/Input.js";
import * as $j_be$002edoeraene$002ewebcomponents$002e$002dWeb$002dComponent from "./be.doeraene.webcomponents.-Web-Component.js";
import * as $j_be$002edoeraene$002ewebcomponents$002eui5$002econfigkeys$002e$002dInput$002dType$0024 from "./be.doeraene.webcomponents.ui5.configkeys.-Input-Type$.js";
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024 from "./com.raquo.laminar.codecs.package$.js";
import * as $j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024 from "./com.raquo.laminar.tags.-Custom-Html-Tag$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lbe_doeraene_webcomponents_ui5_Input$() {
  this.CY = null;
  this.CU = null;
  this.CV = false;
  this.CZ = null;
  this.D0 = false;
  this.CW = null;
  this.CX = false;
  $n_Lbe_doeraene_webcomponents_ui5_Input$ = this;
  $j_be$002edoeraene$002ewebcomponents$002e$002dWeb$002dComponent.$f_Lbe_doeraene_webcomponents_WebComponent__$init$__V(this);
  $i_$0040ui5$002fwebcomponents$002fdist$002fInput$002ejs.default;
  this.CY = new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_tags_CustomHtmlTag("ui5-input", $j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024.$m_Lcom_raquo_laminar_tags_CustomHtmlTag$().eO(), ($j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024.$m_Lcom_raquo_laminar_tags_CustomHtmlTag$(), (void 0)));
}
export { $c_Lbe_doeraene_webcomponents_ui5_Input$ as $c_Lbe_doeraene_webcomponents_ui5_Input$ };
$p = $c_Lbe_doeraene_webcomponents_ui5_Input$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lbe_doeraene_webcomponents_ui5_Input$;
/** @constructor */
function $h_Lbe_doeraene_webcomponents_ui5_Input$() {
}
export { $h_Lbe_doeraene_webcomponents_ui5_Input$ as $h_Lbe_doeraene_webcomponents_ui5_Input$ };
$h_Lbe_doeraene_webcomponents_ui5_Input$.prototype = $p;
$p.fP = (function(x$0) {
});
$p.ec = (function() {
  return this.CY;
});
$p.ju = (function() {
  if ((!this.CV)) {
    this.CU = ($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$(), $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$ct_Lcom_raquo_laminar_keys_HtmlAttr__T__Lcom_raquo_laminar_codecs_Codec__(new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_keys_HtmlAttr(), "placeholder", $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024.$m_Lcom_raquo_laminar_codecs_package$().ci));
    this.CV = true;
  }
  return this.CU;
});
$p.gK = (function() {
  if ((!this.D0)) {
    this.CZ = ($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$(), $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$ct_Lcom_raquo_laminar_keys_HtmlAttr__T__Lcom_raquo_laminar_codecs_Codec__(new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_keys_HtmlAttr(), "type", $j_be$002edoeraene$002ewebcomponents$002eui5$002econfigkeys$002e$002dInput$002dType$0024.$m_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$().wV()));
    this.D0 = true;
  }
  return this.CZ;
});
$p.Cv = (function() {
  if ((!this.CX)) {
    this.CW = ($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$(), $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$ct_Lcom_raquo_laminar_keys_HtmlAttr__T__Lcom_raquo_laminar_codecs_Codec__(new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_keys_HtmlAttr(), "show-clear-icon", $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024.$m_Lcom_raquo_laminar_codecs_package$().gN));
    this.CX = true;
  }
  return this.CW;
});
var $d_Lbe_doeraene_webcomponents_ui5_Input$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lbe_doeraene_webcomponents_ui5_Input$, "be.doeraene.webcomponents.ui5.Input$", ({
  gh: 1,
  ar: 1,
  bG: 1,
  b8: 1
}));
export { $d_Lbe_doeraene_webcomponents_ui5_Input$ as $d_Lbe_doeraene_webcomponents_ui5_Input$ };
var $n_Lbe_doeraene_webcomponents_ui5_Input$;
function $m_Lbe_doeraene_webcomponents_ui5_Input$() {
  if ((!$n_Lbe_doeraene_webcomponents_ui5_Input$)) {
    $n_Lbe_doeraene_webcomponents_ui5_Input$ = new $c_Lbe_doeraene_webcomponents_ui5_Input$();
  }
  return $n_Lbe_doeraene_webcomponents_ui5_Input$;
}
export { $m_Lbe_doeraene_webcomponents_ui5_Input$ as $m_Lbe_doeraene_webcomponents_ui5_Input$ };
